import request from "@/common/request"
import { ValePresente } from "@/models/views/ValePresente"

const basePath = '/vale-presente'

export const findValeValido = (id: string, grupoEconomicoId: string): Promise<ValePresente> =>
	request.get(`${basePath}/${id}?grupoEconomicoId=${grupoEconomicoId}`)

export const findValesPresentesByVendaId = (vendaId: string): Promise<ValePresente[]> =>
	request.get(`${basePath}/venda/${vendaId}`)